export const getPageType = (routeName) => {
    if (routeName.includes('category')) return 'catPage'
    if (routeName.includes('brand')) return 'brandPage'
    if (routeName.includes('product')) return 'productLinePage'
    if (routeName.includes('specials')) return 'specialsPage'
    if (routeName === 'sku') return 'skuPage'
    if (routeName === 'mmy') return 'vehiclePage'
}

// Get Page Name from Title
export const getPageName = (siteName) => {
    const title = document.title
    const cleanTitle = title.replace('| ' + siteName, '')
    return cleanTitle.trim()
}
